import { createAsyncThunk } from '@reduxjs/toolkit';
import createGenericSlice, { GenericState } from '../wrapper/sliceWrapper';
import Module from '../../utils/Module/Module';
import IModuleList from '../../utils/ModuleList/ModuleList.interface';

interface IActionType {
  payload: IModuleList;
  type: string;
}

interface IRenameOwnerAction {
  payload: { oldName: string; newName: string };
  type: string;
}

const initialState: GenericState<Array<IModuleList> | null> = { data: null, status: 'loading' };

export const getAllModules = createAsyncThunk('modules/getAllModules', async () => {
  const module = new Module();
  return await module.getAllModule();
});

const moduleSlice = createGenericSlice({
  name: 'modules',
  initialState,
  reducers: {
    updateModule: (state, action: IActionType) => {
      state.data = state.data
        ? state.data.map((item) =>
            item.moduleName === action.payload.moduleName ? action.payload : item
          )
        : state.data;
    },
    renameModuleOwner: (state, action: IRenameOwnerAction) => {
      if (state.data) {
        state.data.forEach((item) => {
          if (item.owner === action.payload.oldName) {
            item.owner = action.payload.newName;
          }
        });
      }
    },
    // reset to initial state
    resetModuleState: (state) => {
      state = initialState;
    }
  },
  extraReducers: (builder) => {
    // getAllModules cases
    builder.addCase(getAllModules.pending, (state) => {
      state.status = 'loading';
    });

    builder.addCase(getAllModules.fulfilled, (state, action) => {
      state.status = 'finished';
      state.data = action.payload;
    });

    builder.addCase(getAllModules.rejected, (state, action) => {
      state.status = 'error';
      state.error = 'Something went wrong.';
    });
  }
});

export const { updateModule, renameModuleOwner, resetModuleState } = moduleSlice.actions;
export default moduleSlice.reducer;
